import VillaDetails from './VillaDetails';

export default VillaDetails;
